// @ts-expect-error untyped
import getDateNumberFormattingLocale from '../../getDateNumberFormattingLocale';

export const alternativeFractionCurrencies: Record<string, number> = {
  CLP: 2,
  COP: 2,
};

export const INTL_DEFAULT_MIN_FRACTIONAL_DIGITS = 2;

export const getLocale = (options?: { locale?: string }) => {
  return (options && options.locale) || getDateNumberFormattingLocale();
};

export interface Options {
  abbreviate?: boolean;
  currencyCode?: string | null;
  currencyDisplay?: 'symbol' | 'code' | 'narrowSymbol' | 'name';
  currencySign?: 'standard' | 'accounting';
  locale?: string;
  maximumFractionDigits?: number;
  parts?: Partial<Record<Intl.NumberFormatPartTypes, string>>;
  precision?: number;
  stripInsignificantZeros?: boolean;
  trailingZeroDisplay?: 'auto' | 'stripIfInteger';
  unit?: string;

  /**
   * @deprecated Use currencySign: formatNegativeValuesWithParenthesis ? 'accounting' : 'standard' instead
   */
  formatNegativeValuesWithParenthesis?: boolean;
  /**
   * @deprecated Use currencyDisplay: useCurrencyCode ? 'code' : 'symbol' instead
   */
  useCurrencyCode?: boolean;
  /**
   * @deprecated Use trailingZeroDisplay: simplifyCurrency ? 'stripIfInteger' : 'auto' instead
   */
  simplifyCurrency?: boolean;
}

export const getOptions = (options?: Options) => {
  const opts: Intl.NumberFormatOptions = {};
  if (options) {
    if (typeof options.precision === 'number') {
      opts.maximumFractionDigits = options.precision;

      if (options.stripInsignificantZeros === false) {
        opts.minimumFractionDigits = options.precision;
      }
    }

    if (typeof options.maximumFractionDigits === 'number') {
      opts.maximumFractionDigits = options.maximumFractionDigits;
    }

    if (options.abbreviate === true) {
      opts.notation = 'compact';
      // Matching FormattedCurrency's default behavior of having 0 decimal places when abbreviating
      opts.maximumFractionDigits = opts.maximumFractionDigits ?? 0;
      // @ts-expect-error trailingZeroDisplay is not typed as part of the Intl API
      opts.trailingZeroDisplay = 'stripIfInteger';
    }

    if (
      opts.maximumFractionDigits !== undefined &&
      opts.maximumFractionDigits < INTL_DEFAULT_MIN_FRACTIONAL_DIGITS
    ) {
      // https://github.com/andyearnshaw/Intl.js/issues/123
      opts.minimumFractionDigits = opts.maximumFractionDigits;
    }

    if (options.useCurrencyCode === true) {
      opts.currencyDisplay = 'code';
    }

    if (
      options.simplifyCurrency === true ||
      options.trailingZeroDisplay === 'stripIfInteger'
    ) {
      // @ts-expect-error trailingZeroDisplay is not typed as part of the Intl API
      opts.trailingZeroDisplay = 'stripIfInteger';
    }

    if (typeof options.currencyDisplay === 'string') {
      opts.currencyDisplay = options.currencyDisplay;
    }

    if (typeof options.currencySign === 'string') {
      opts.currencySign = options.currencySign;
    }
  }
  return opts;
};
